module.exports = __webpack_public_path__ + "static/media/new-collection-back.6f074d44.svg";